import { render, staticRenderFns } from "./DataDetailRow.vue?vue&type=template&id=061796ca"
import script from "./DataDetailRow.vue?vue&type=script&lang=js"
export * from "./DataDetailRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports